import { useMemo } from 'react';
import { withHooks } from '../../../shared/lib/withHooks';
import { useCurrentArtist } from './useCurrentArtist';
import { useCurrentArtistPermissions } from './useCurrentArtistPermissions';

export const withDeprecatedCurrentArtist = withHooks(() => {
  const currentArtist = useCurrentArtist();
  const permissions = useCurrentArtistPermissions();
  const artist = useMemo(
    () => ({
      id: currentArtist.id,
      name: currentArtist.name,
      imageUrl: currentArtist.imageUrl,
      permissions,
    }),
    [currentArtist, permissions],
  );
  return { artist };
}, 'DeprecatedCurrentArtist');
